(function() {
  'use strict';

  var config = window.__searchFallbackConfig;
  if (!config || !config.terms || !config.performed) return;

  var THRESHOLD = 6;
  var FLOOD_THRESHOLD = 100;
  var nativeCount = Number(config.nativeProductCount || 0);
  var nativeTotal = Number(config.nativeTotalCount || nativeCount);
  if(nativeCount>0)return;

  function cleanTerm(value) {
    return (value || '').trim().replace(/\*+$/, '');
  }

  function makePreciseTerm(value) {
    var term = cleanTerm(value);
    if (!term) return '';

    // Não interfere em uma pesquisa avançada criada manualmente.
    if (/["():]/.test(term) || /\b(?:AND|OR|NOT)\b/i.test(term)) {
      return term;
    }

    var words = term.split(/\s+/);
    words[words.length - 1] += '*';
    return words.join(' ');
  }

  function isShortCode(value) {
    var term = cleanTerm(value);
    if (!term || /\s/.test(term)) return false;
    if (term.length <= 6) return true;
    return (
      /\d/.test(term) &&
      /^[a-z0-9-]+$/i.test(term) &&
      term.length <= 12
    );
  }

var term = cleanTerm(config.terms);
  var preciseTerm = makePreciseTerm(term);
  var overrideCandidate =
    isShortCode(term) && nativeTotal >= FLOOD_THRESHOLD;

  // Com seis ou mais resultados coerentes, a grade nativa é mantida.
  if (!overrideCandidate && nativeCount >= THRESHOLD) return;

  // Se a própria página já veio com a busca precisa, não faz outra requisição.
  if (
    /\*+\s*$/.test(config.terms) &&
    nativeCount > 0 &&
    !overrideCandidate
  ) {
    return;
  }

  if (!preciseTerm) return;

  var currentGrid = document.getElementById('product-grid');
  if (!currentGrid) return;

  var currentSection = currentGrid.closest('[id^="shopify-section-"]');
  var originalVisibility = currentGrid.style.visibility;
  var loadingMessage = null;

  /*
   * Quando a pesquisa nativa devolve centenas de itens sem relação, oculta a
   * grade incorreta enquanto a versão precisa é carregada. Em caso de falha,
   * a grade original volta a aparecer.
   */
  if (overrideCandidate) {
    currentGrid.style.visibility = 'hidden';
    currentGrid.setAttribute('aria-busy', 'true');

    loadingMessage = document.createElement('p');
    loadingMessage.className = 'predictive-fallback-loading';
    loadingMessage.setAttribute('role', 'status');
    loadingMessage.textContent = 'Buscando produtos...';
    currentGrid.parentNode.insertBefore(loadingMessage, currentGrid);
  }

  var preciseUrl = new URL(window.location.href);
  preciseUrl.searchParams.set('q', preciseTerm);
  preciseUrl.searchParams.set('type', 'product');
  preciseUrl.searchParams.set('options[prefix]', 'last');
  preciseUrl.hash = '';

  fetch(preciseUrl.toString(), {
    credentials: 'same-origin',
    headers: {
      Accept: 'text/html',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(function(response) {
      if (!response.ok) throw new Error('Falha na busca precisa');
      return response.text();
    })
    .then(function(html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var preciseGrid = parsed.getElementById('product-grid');
      if (!preciseGrid) throw new Error('Grade precisa não encontrada');

      var preciseCards = preciseGrid.querySelectorAll(
        'ul.product-grid > li, ul#product-grid > li'
      );
      var preciseCount = preciseCards.length;

      /*
       * No modo complementar, só troca a grade quando a consulta precisa
       * realmente encontrou mais produtos. No override, troca sempre que
       * encontrou ao menos um produto coerente.
       */
      if (
        preciseCount === 0 ||
        (!overrideCandidate && preciseCount <= nativeCount)
      ) {
        throw new Error('A busca precisa não melhorou os resultados');
      }

      var preciseSection = null;
      if (currentSection && currentSection.id) {
        preciseSection = parsed.getElementById(currentSection.id);
      }
      if (!preciseSection) {
        preciseSection = preciseGrid.closest('[id^="shopify-section-"]');
      }

      if (currentSection && preciseSection) {
        /*
         * Reutiliza todo o HTML renderizado pelo próprio tema: cards, botão de
         * carrinho, disponibilidade, esgotado, promoções, filtros e paginação.
         */
        currentSection.innerHTML = preciseSection.innerHTML;
      } else {
        currentGrid.replaceWith(preciseGrid);
      }

      /*
       * Mantém a URL coerente com os resultados exibidos. O campo da busca
       * continua sem o asterisco por causa do search-precision.js.
       */
      window.history.replaceState(
        window.history.state,
        '',
        preciseUrl.pathname + preciseUrl.search
      );

      document.dispatchEvent(
        new CustomEvent('fallback:products-loaded', {
          detail: {
            nativeMarkup: true,
            preciseTerm: preciseTerm,
            productCount: preciseCount
          }
        })
      );
    })
    .catch(function() {
      if (currentGrid && currentGrid.isConnected) {
        currentGrid.style.visibility = originalVisibility;
        currentGrid.removeAttribute('aria-busy');
      }
    })
    .finally(function() {
      if (loadingMessage && loadingMessage.isConnected) {
        loadingMessage.remove();
      }
    });
})();